import { t } from "i18next";
import React from "react";

import ApplicationLayout from "components/layout/ApplicationLayout";
import { SINGLE_SIGN_ON_SETTINGS_ROUTE } from "components/router/Routes";
import { SingleSignOnSettingsSubpage } from "components/settings/views/single-sign-on-settings/SingleSignOnSettingsSubpage";

export const SingleSignOnSettingsView = () => {
    return (
        <ApplicationLayout
            viewTitle={t("Routes.singleSignOn")}
            view={<SingleSignOnSettingsSubpage />}
            mainRoute={SINGLE_SIGN_ON_SETTINGS_ROUTE}
        />
    );
};
